import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'recurrenceSettings.recurrenceWhen.dropdown.label' }),
  }))

  return api
}
